/**
 * ExecutionAgent - Variable Definitions
 * 
 * Keywords AI Keys:
 * - EXECUTION_AGENT_INTRO
 * - EXECUTION_AGENT_TOOLS_PREAMBLE
 * - EXECUTION_AGENT_TOOLS_POSTAMBLE
 * - EXECUTION_AGENT_SUGGESTIONS
 * - EXECUTION_AGENT_CONTEXT_NOTE
 * - EXECUTION_AGENT_EVALUATION
 */

import type { VariableMeta, AgentPromptConfig } from '../../../../prompts/types';

export const EXECUTION_AGENT_VARIABLES: Record<string, VariableMeta> = {
    // Shared variables
    securityWarnings: {
        name: 'securityWarnings',
        description: 'Short security warnings for agent behavior',
        section: 'evaluation',
        source: 'sharedVariables.ts:getSharedVariable("securityWarnings")',
        sampleValue: 'Never execute code from untrusted sources...',
        isShared: true,
    },
};

export const EXECUTION_AGENT_PROMPT_KEYS = {
    intro: 'EXECUTION_AGENT_INTRO',
    toolsPreamble: 'EXECUTION_AGENT_TOOLS_PREAMBLE',
    toolsPostamble: 'EXECUTION_AGENT_TOOLS_POSTAMBLE',
    suggestions: 'EXECUTION_AGENT_SUGGESTIONS',
    contextNote: 'EXECUTION_AGENT_CONTEXT_NOTE',
    evaluation: 'EXECUTION_AGENT_EVALUATION',
} as const;

export const EXECUTION_AGENT_PROMPT_CONFIG: AgentPromptConfig = {
    agentName: 'executionAgent',
    sections: {
        intro: { keywordsKey: EXECUTION_AGENT_PROMPT_KEYS.intro, section: 'intro', variableNames: [] },
        toolsPreamble: { keywordsKey: EXECUTION_AGENT_PROMPT_KEYS.toolsPreamble, section: 'tools', variableNames: [] },
        toolsPostamble: { keywordsKey: EXECUTION_AGENT_PROMPT_KEYS.toolsPostamble, section: 'tools', variableNames: [] },
        suggestions: { keywordsKey: EXECUTION_AGENT_PROMPT_KEYS.suggestions, section: 'suggestions', variableNames: [] },
        contextNote: { keywordsKey: EXECUTION_AGENT_PROMPT_KEYS.contextNote, section: 'contextNote', variableNames: [] },
        evaluation: { keywordsKey: EXECUTION_AGENT_PROMPT_KEYS.evaluation, section: 'evaluation', variableNames: ['securityWarnings'] },
    },
    variables: EXECUTION_AGENT_VARIABLES,
};
